import request from '@/utils/request'
import { parsePhoneNumberFromString } from 'libphonenumber-js/mobile'
import textHelpers from '@/utils/textHelpers'
import type { ContactFormData } from '@/types/contact'

const contactService = {
  async postForm(body: ContactFormData): Promise<void> {
    const path = '/ContactUs'
    await request.post(
      import.meta.env.VITE_ALTERNATE_API_URL + path,
      body
    )
  },

  validateFormData(formData: ContactFormData): string[] {
    const errors: string[] = []
    const mailFormatValid = formData.email ? textHelpers.emailValidator(formData.email) : true
    let validPhone = false

    if (formData.phoneNumber && formData.phoneNumber > 0) {
      const phoneResult = parsePhoneNumberFromString(
        formData.phoneNumber.toString(),
        'IL'
      )
      validPhone = phoneResult ? phoneResult.isValid() : false
    }

    if (!formData.email && !formData.phoneNumber) {
      errors.push('MissingEmailAndPhone')
    }
    
    if (formData.phoneNumber && formData.phoneNumber > 0 && !validPhone) {
      errors.push('PhoneNumberInvalid')
    }
    
    if (formData.email && !mailFormatValid) {
      errors.push('EmailInvalid')
    }
    
    return errors
  },
}

export default contactService
